import { createSelector } from 'reselect';
import { name, initialState } from './slice';

export const packagePaquerypointDepartureSelector = (state) =>
  state[name] || initialState;

export const packagePaquerypointDepartureItemsSelector = (state) =>
  Object.values(state[name].items);

export const packagePaquerypointDepartureLoadedSelector = (state) =>
  state[name].loaded;

export const packagePaquerypointDeparturePageableSelector = (state) =>
  state[name].pageable;

export const packagePaquerypointDepartureSearchSelector = (state) =>
  (state[name] || initialState).search;

const makePackagePaquerypointDepartureSelector = () =>
  createSelector(packagePaquerypointDepartureSelector, (substate) => substate);

// El destino se pasa como argumento porque cada pantalla lo guarda en su propio
// slice: Transferir de PP en `packageDeparture`, la de OPL en
// `packageLogisticOperatorDeparture`. Leerlo de uno fijo rompe la otra pantalla.
export const packagePaquerypointFilteredItemsSelector = createSelector(
  packagePaquerypointDepartureItemsSelector,
  packagePaquerypointDeparturePageableSelector,
  packagePaquerypointDepartureSearchSelector,
  (_state, destiny) => destiny,
  (items, { pageSize, pageNumber }, search, destiny) => {
    if (!destiny) {
      return [];
    }
    let resultItems = items;
    if (search) {
      resultItems = resultItems.filter((item) => {
        const searchIgnoreCase = search.toUpperCase();
        const externalCodeIgnoreCase = item.externalCode.toUpperCase();
        return (
          externalCodeIgnoreCase &&
          externalCodeIgnoreCase.includes(searchIgnoreCase)
        );
      });
    }
    if (destiny) {
      resultItems = resultItems.filter((item) => item.destinyID === destiny);
    }
    const start = pageNumber * pageSize;
    const end = pageNumber * pageSize + pageSize;
    const totalElements = resultItems.length;
    resultItems = resultItems.slice(start, end);
    return {
      pageable: {
        pageNumber,
        pageSize,
        totalElements,
      },
      items: resultItems,
    };
  },
);

export default makePackagePaquerypointDepartureSelector;

export const packagePaquerypointDepartureAllPaqueryPointsItemsSelector = (
  state,
) => (state[name] || initialState).paquerypoints;

export const packagePaquerypointDepartureAllPaqueryPointsLoadedSelector = (
  state,
) => (state[name] || initialState).paquerypointsLoaded;
